module.exports = __webpack_public_path__ + "static/media/logo.5b3de3e7.png";